export default "__VITE_ASSET__75761682__"